import React from 'react';

const Row = ({ params, row, onActionsPopup }) => {
    let td = getValues(params, row);

    return (
        <tr onClick={() => onActionsPopup(row.actions)}>{td}</tr>
    );
};

function getValues(params, row) {
    return params.map((param) => {
        const value = row[param];

        return(<td key={param}>{value}</td>);
    });
}

export default Row;



// WEBPACK FOOTER //
// ./src/scenes/History/components/Table/components/Row/index.js